// extracted by mini-css-extract-plugin
export default {"overlay":"modal_overlay__oiiQV","content":"modal_content__oZMCN","body":"modal_body__c5Anh"};